import { useCheckVersion } from "./useCheckVersion";
import { useNotifications } from "./useNotifications";
export const BackgroundHooks = () => {
  useCheckVersion();
  useNotifications();
  return <></>;
};
